export const COOKIE_KEYS = {
  LOGGED_IN: "logged_in",
  HAS_EXPENSES: "has-expenses",
} as const;

type CookieKey = (typeof COOKIE_KEYS)[keyof typeof COOKIE_KEYS];

export function getCookies() {
  const cookies = document.cookie.split("; ");
  const cookieMap = new Map<CookieKey, string>();

  cookies.forEach((cookie) => {
    const [key, value] = cookie.split("=");
    cookieMap.set(key as CookieKey, value);
  });

  return cookieMap;
}

export function setCookie(key: CookieKey, value: string) {
  document.cookie = `${key}=${value}`;
}

export function deleteCookie(name: CookieKey) {
  // Set the cookie with an empty value and an expiry date in the past
  document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
}
